import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Card, CardContent, Typography, Divider, Box } from "@mui/material";
import { useEffect, useState } from "react";
import regionsData from "@/app/features/company/data/regions_lite.json";
import citiesData from "@/app/features/company/data/cities_lite.json";

interface Company {
  id: string;
  nameAr: string;
  nameEn: string;
  address: string;
  region: string;
  city: string;
  CompanyNr: string;
}

interface City {
  city_id: number;
  region_id: number;
  name_ar: string;
}
interface Region {
  region_id: number;
  name_ar: string;
}
interface Option {
  value: string;
  label: string;
}
interface Order {
  id: string;
  title: string;
  deliverDate: string;
  city: string;
  address: string;
  OrderNr: number;
  company: Company;
  buyCompany: Company;
  status: string;
  DeliveryMethod: string;
  paymentMethod: string;
}
function CompanyCard({ order }: { order: Order }) {
  const [regions, setRegions] = useState<Option[]>([]);
  const [cities, setCities] = useState<Option[]>([]);

  useEffect(() => {
    setCities(
      citiesData.map((City: City) => ({
        value: City.city_id.toString(),
        label: City.name_ar,
      }))
    );
    setRegions(
      regionsData.map((region: Region) => ({
        value: region.region_id.toString(),
        label: region.name_ar,
      }))
    );
  }, []);
  const getCity = (value: string) => {
    let city = cities.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };

  const getRegion = (value: string) => {
    let city = regions.find((item) => parseInt(item.value) === parseInt(value));
    if (city) {
      return city.label;
    } else {
      return "";
    }
  };
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        boxShadow: "none",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#1a1a1a",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          🏢 {t("orders.buyerCompanyDetails")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("company.fields.CompanyNr")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {order.buyCompany?.CompanyNr}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("company.fields.region")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {getRegion(order.buyCompany?.region)}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("company.fields.city")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {getCity(order.buyCompany?.city)}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default CompanyCard;
